"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountGroupData = void 0;
const ChartingPalette_1 = __importDefault(require("@opsbase/lib-palette/ChartingPalette"));
const utils_1 = require("@opsbase/lib-time/utils");
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const react_1 = require("react");
function useCountGroupData(dimension) {
    var _a, _b, _c, _d, _e, _f;
    const dt = (0, useDataTree_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const [changed, setChanged] = (0, react_1.useState)();
    const loading = (0, react_1.useRef)(true);
    const data = (0, react_1.useRef)([]);
    const lastChanged = (0, react_1.useRef)();
    const groupBy = view.groupBys.find(gb => gb.queryFieldKey === dimension);
    const groups = (_a = dt.groupsForGroupBy) === null || _a === void 0 ? void 0 : _a.get(groupBy);
    const totalCount = (_b = dt.totalCountForNode) === null || _b === void 0 ? void 0 : _b.get(dt.rootNode);
    const isLoading = ((_c = dt.dataStatus) === null || _c === void 0 ? void 0 : _c.loadingAggs) || ((_d = dt.dataStatus) === null || _d === void 0 ? void 0 : _d.loadingGroups);
    const autoPalette = ChartingPalette_1.default.generatePalette((groups === null || groups === void 0 ? void 0 : groups.length) || 0);
    const mostRecentChange = (0, utils_1.mostRecent)([
        (_e = dt.dataStatus) === null || _e === void 0 ? void 0 : _e.aggsLastLoaded,
        (_f = dt.dataStatus) === null || _f === void 0 ? void 0 : _f.groupsLastLoaded,
        view === null || view === void 0 ? void 0 : view.highlightsChanged,
    ]);
    (0, react_1.useEffect)(() => {
        // If the data isn't ready, we're not ready
        if (isLoading && !loading.current) {
            loading.current = true;
            return setChanged(new Date());
        }
        if (isLoading)
            return;
        // No need to update if data we're interested in hasn't changed
        if (lastChanged.current >= mostRecentChange)
            return;
        // Build the Chart Data
        lastChanged.current = new Date();
        loading.current = false;
        // Get the Data
        data.current = groups
            .map((group, idx) => {
            const id = group.id;
            const color = group.color || autoPalette[idx];
            const label = group.title;
            const count = dt.totalCountForGroup.get(group);
            const perc = Math.round((count / totalCount) * 100);
            return count > 0
                ? {
                    xDim: { id, label },
                    x: idx + 1,
                    y: count,
                    yRaw: count,
                    color1: color.main,
                    color2: color.dark,
                    label: `${count} (${perc}%) ${label}`,
                }
                : undefined;
        })
            // Remove empty groups
            .filter(v => !!v);
        // Update CTX
        setChanged(new Date());
    }, [autoPalette, dt.totalCountForGroup, groups, isLoading, mostRecentChange, totalCount]);
    return (0, react_1.useMemo)(() => ({
        loading: loading.current,
        data: data.current,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changed]);
}
exports.useCountGroupData = useCountGroupData;
exports.default = useCountGroupData;
